import React from "react";

// Shown instead of a blank page when the app crashes while drawing. The small
// print (error + browser) lets a visitor's screenshot tell us what went wrong.
const AppCrash = ({ error }) => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-surface-950 text-white text-center px-6">
    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-accent-500 to-pink-500 flex items-center justify-center text-2xl font-extrabold">
      T
    </div>
    <p className="text-lg font-semibold">Nəsə səhv getdi.</p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      className="bg-white text-surface-900 rounded-xl px-6 py-3 text-sm font-semibold"
    >
      Yenidən yüklə
    </button>
    <small className="max-w-sm text-[10px] leading-relaxed text-white/40 break-all">
      {String(error?.message || error)} · {navigator.userAgent}
    </small>
  </div>
);

export default AppCrash;
